module.exports = __webpack_public_path__ + "img/lux.c73182da.png";